import React from "react"
import { StaticQuery, graphql } from "gatsby"
import styled from "styled-components"
import BackgroundImage from "gatsby-background-image"

const BackgroundSection = ({ className, title, hero }) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          allImageSharp {
            edges {
              node {
                fluid(quality: 90, maxWidth: 1920) {
                  ...GatsbyImageSharpFluid_withWebp
                  originalName
                }
              }
            }
          }
        }
      `}
      render={data => {
        const imageData = data.allImageSharp.edges.find(
          edge => edge.node.fluid.originalName === hero
        )
        const backgroundFluidImageStack = [
          `linear-gradient(rgba(126,66,15, 0.50), rgba(126,66,15, 0.50))`,
          imageData.node.fluid,
        ]
        if (!imageData) {
          return null
        }
        return (
          <BackgroundImage
            Tag="section"
            className={className}
            fluid={backgroundFluidImageStack}
            backgroundColor={`#040e18`}
          >
            <h1>{title}</h1>
          </BackgroundImage>
        )
      }}
    />
  )
}

const Hero = styled(BackgroundSection)`
  width: 100%;
  max-width: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  h1 {
    padding: var(--hero-xl) 0;
    font-size: 3rem;
    line-height: 3.5rem;
    text-align: center;
    color: white;
    font-weight: bold;
    @media (max-width: 640px) {
      font-size: 1.6rem;
    }
  }
`

export default Hero
